module.exports = __webpack_public_path__ + "static/media/wholeAstronaut.29447091.png";